<div class="au-filters m-b-sxs" [ngClass]="containerClass">
	<mat-form-field
		hideRequiredMarker
		class="au-search-input no-label"
		floatLabel="never"
		[subscriptSizing]="subscriptSizingMode"
	>
		<input
			autocomplete="off"
			type="text"
			matInput
			[placeholder]="placeholder"
			[formControl]="formControl"
			(focus)="focusChanged.emit(true)"
			(blur)="focusChanged.emit(false)"
		/>
		<mat-icon svgIcon="search" matSuffix class="magnifier-icon"></mat-icon>
	</mat-form-field>
</div>
